import React from "react";
import styles from "./MatrixGrid.module.css";


const MatrixGrid = ({matrix, setMatrix, editable = false, index = 1}) => {
    return (
        <div className={styles.wrapper}>
            {matrix.to2DArray().map((row, nRow) => {
                return (
                    <div key={nRow}>
                        {row.map((elem, nColumn) => 
                            <input
                                className={styles.inp_box}
                                type="int"
                                value={elem}
                                key={index*(nColumn*1000 + nRow)}
                                onChange={e => {
                                    e.preventDefault();
                                    if(editable)
                                        setMatrix(prevMatrix => prevMatrix.set(nRow, nColumn, e.target.value).clone());
                                }}
                            />
                        )}
                        <p/>
                    </div>
                )
            })}
        </div >
    );
}

export default MatrixGrid;